import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

const StudentDuplicateModal = ({ show, duplicateInfo, onConfirm, onClose }) => {
  if (!show || !duplicateInfo) return null;

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Uwaga - duplikat ucznia</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Uczeń <strong>{duplicateInfo.firstName} {duplicateInfo.lastName || ''}</strong> już istnieje
          i jest dodany do klienta <strong>{duplicateInfo.clientName || duplicateInfo.clientId}</strong>.
        </p>
        <p className="mb-0">Czy na pewno chcesz zapisać?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Anuluj
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          Tak, zapisz mimo to
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

StudentDuplicateModal.propTypes = {
  show: PropTypes.bool.isRequired,
  duplicateInfo: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string,
    clientName: PropTypes.string,
    clientId: PropTypes.string,
  }),
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

StudentDuplicateModal.defaultProps = {
  duplicateInfo: null,
};

export default StudentDuplicateModal;
